/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, styled, TextField, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { DepartmentType } from "../../../../common/const";
import { apiRequest } from "../../../../common/common";
import { LoadingPage } from "../../../../common/LoadingPage";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
    flexGrow: 1,         // Take up available space
    overflowY: 'auto',   // Enable scrolling if content overflows
    paddingBottom: 30,   // Ensure space for the fixed footer
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
    width: '100%',
});

export default function FilterPanel({
    applyFilter,
    projectId
}) {
    const [expanded, setExpanded] = useState(false);
    const [filters, setFilters] = useState(localStorage.getItem('depfilters') ? JSON.parse(localStorage.getItem('depfilters')) : {});
    const [dataLoading, setDataLoading] = useState(false);
    const [phaseData, setPhaseData] = useState([]);
    const [costData, setCostData] = useState([]);
    const [buildingData, setBuildingData] = useState([]);
    const [levelData, setLevelData] = useState([]);

    const getPhase = async () => {
        try {
            setDataLoading(true);
            const url = [
                `/department/phases?projectId=${projectId}`,
                `pageNo=1`,
                `pageSize=100`,
            ].filter(Boolean).join('&');
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setPhaseData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getCostCentre = async () => {
        try {
            setDataLoading(true);
            const url = [
                `/department/cost-center?projectId=${projectId}`,
                `pageNo=1`,
                `pageSize=100`,
            ].filter(Boolean).join('&');
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setCostData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getBuilding = async () => {
        setDataLoading(true);
        const url = [
            `/building?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setBuildingData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getLevel = async () => {
        setDataLoading(true);
        const url = [
            `/level?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setLevelData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const handleChange = (panel) => (event, isExpanded) => {
        if (panel === 'panel1' && isExpanded) {
            const obj = filters;
            if (!obj?.isDeleted) {
                obj.isDeleted = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel2' && isExpanded) {
            const obj = filters;
            if (!obj?.departmentType) {
                obj.departmentType = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel3' && isExpanded) {
            getBuilding();
            const obj = filters;
            if (!obj?.building) {
                obj.building = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel4' && isExpanded) {
            getLevel();
            const obj = filters;
            if (!obj?.level) {
                obj.level = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel5' && isExpanded) {
            getPhase();
            const obj = filters;
            if (!obj?.areaPhase) {
                obj.areaPhase = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel6' && isExpanded) {
            getCostCentre();
            const obj = filters;
            if (!obj?.costCentre) {
                obj.costCentre = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel7' && isExpanded) {
            const obj = filters;
            if (!obj?.isNotes) {
                obj.isNotes = null;
            }
            setFilters(obj);
        }
        setExpanded(isExpanded ? panel : false);
    };

    const handleFilter = async () => {
        if (filters?.departmentType?.length === 0) {
            showNotification('Please select any one filter before apply', 'error');
        } else if (filters?.building?.length === 0) {
            showNotification('Please select value from Building', 'error');
        } else if (filters?.level?.length === 0) {
            showNotification('Please select value from Level', 'error');
        } else if (filters?.areaPhase?.length === 0) {
            showNotification('Please select Area Phase', 'error');
        } else if (filters?.costCentre?.length === 0) {
            showNotification('Please select Cost Centre', 'error');
        } else {
            setExpanded(false);
            await applyFilter(filters);
        }
    }

    return (
        <CustomFilterPanelWrapper>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Filters</Typography>
            <FilterContent>
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.departmentType?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Department Type</Typography>
                            </Box>
                            {expanded === 'panel2' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.departmentType;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={DepartmentType.filter((c) => filters?.departmentType?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={DepartmentType}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    departmentType: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Department Type"
                                    name="Department Type"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.isDeleted === 'yes' || filters?.isDeleted === 'no') && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">InActive Department</Typography>
                            </Box>
                            {expanded === 'panel1' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.isDeleted;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.isDeleted === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.isDeleted === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.building?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Building</Typography>
                            </Box>
                            {expanded === 'panel3' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.building;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={buildingData.filter((c) => filters?.building?.includes(c.building_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={buildingData}
                            getOptionLabel={(option) => option?.building_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.building_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    building: newValue.map((a) => a.building_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Building"
                                    name="Building"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.level?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Level</Typography>
                            </Box>
                            {expanded === 'panel4' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.level;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={levelData.filter((c) => filters?.level?.includes(c.level_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={levelData}
                            getOptionLabel={(option) => option?.level_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.level_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    level: newValue.map((a) => a.level_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Level"
                                    name="Level"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5-content"
                        id="panel5-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.areaPhase?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Area / Phase Name</Typography>
                            </Box>
                            {expanded === 'panel5' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.areaPhase;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={phaseData.filter((c) => filters?.areaPhase?.includes(c.phase_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={phaseData}
                            getOptionLabel={(option) => option?.phase_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.phase_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    areaPhase: newValue.map((a) => a.phase_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Area / Phase Name"
                                    name="Area / Phase Name"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6-content"
                        id="panel6-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.costCentre?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Cost Center</Typography>
                            </Box>
                            {expanded === 'panel6' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.costCentre;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={costData.filter((c) => filters?.costCentre?.includes(c.cost_centre_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={costData}
                            getOptionLabel={(option) => option?.cost_centre_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.cost_centre_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    costCentre: newValue.map((a) => a.cost_centre_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Cost Center"
                                    name="Cost Center"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel7-content"
                        id="panel7-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.isNotes === 'yes' || filters?.isNotes === 'no') && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Notes</Typography>
                            </Box>
                            {expanded === 'panel7' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.isNotes;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.isNotes === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isNotes: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.isNotes === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isNotes: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </FilterContent>
            <FilterFooter>
                <FixedButton variant="outlined" color="secondary" onClick={() => {
                    applyFilter({});
                    setFilters({});
                    setExpanded(false);
                    localStorage.removeItem('depfilters');
                }}>Clear</FixedButton>
                <FixedButton variant="outlined" color="primary" onClick={() => handleFilter()}>Apply</FixedButton>
            </FilterFooter>
        </CustomFilterPanelWrapper>
    )
}